import styled from 'styled-components';
import { spacing } from 'syf-component-library/defaultTheme';
import { FooterContainer } from 'syf-component-library/ui/patterns/SlideInModal/subcomponents';
export const SettlementReviewEditWrapper = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: ${spacing.large}px;
`;
export const FooterWrapperWithZIndex = styled(FooterContainer) `
  z-index: 1;
`;
